import { createVanIconComponent } from "./van"

const Close = createVanIconComponent("close")
export default Close
